export default __webpack_public_path__ + "static/media/1_1_4.b0daa382.png";